import React, { useEffect, useState } from 'react';
import { Modal, Typography, Row, Col, Collapse, Divider, Form, message, Button, Steps } from 'antd';
import { LockOutlined, DownOutlined, UpOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
// import { InputNumber } from 'afrodita';
import { isMobileOnly } from 'react-device-detect';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

const { Text } = Typography;
const { Panel } = Collapse;
const { Step } = Steps;

export type StoreAuth = {
	token: string;
	roles: string;
	operations: any;
};

export type ReduxStore = {
	auth: StoreAuth;
};
type Props = {
	userMortgageId: any;
	clickTab: any;
	env: any;
	mortgage: any;
	platform: string;
	traceSadabdell: any;
};
function AutomaticDocumentationStartupModal({
	userMortgageId,
	clickTab,
	mortgage,
	env,
	platform,
	traceSadabdell
}: Props) {
	const { t, i18n } = useTranslation();
	const [form] = Form.useForm();
	const navigate = useNavigate();
	const userToken = useSelector<ReduxStore, string>((state) => state.auth.token);
	const [activeModals, setActiveModals] = useState(false);
	const [activeButton, setActiveButton] = useState(true);
	const [showSecurity, setShowSecurity] = useState(false);
	const showSavings = false; //mostrar o no el input de ahorros en el modal de documentación de sabadell
	const operationType = mortgage.subtype;
	const [closeDisabled, setCloseDisabled] = useState(
		operationType === 'mortgage' && platform === 'sabadell' && showSavings ? true : false
	);

	useEffect(() => {
		if (mortgage?.operationData[clickTab]?.viewModalsAutomatic) {
			setActiveModals(false);
		} else {
			if (mortgage?.managementCode === 'sabadell-es') {
				axios
					.get(
						`${env.api.url}/sb/mortgages/predictions/limitations-by-prediction/${userMortgageId}/mortgage`,

						{
							headers: { Authorization: `Bearer ${userToken}` }
						}
					)
					.then((response) => {
						if (response.data.data.isDocumentationLimited === false) {
							setActiveModals(true);
							saveData();
						} else {
							setActiveModals(false);
						}
					});
			} else {
				setActiveModals(true);
				saveData();
			}

			if (traceSadabdell) {
				const language = i18n.language === 'cat' ? 'ca' : 'es';
				traceSadabdell('inicio', language);
			}
		}

		setTimeout(() => {
			setActiveButton(false);
		}, 3000);
	}, []);

	const saveData = () => {
		const key = 'viewModalsAutomatic';
		const participant = clickTab;
		const value = true;

		const key2 = 'docOnboardingDate';
		const participant2 = 'process';
		const value2 = moment().format('YYYY-MM-DD');

		axios
			.post(
				`${env.api.url}/v1/mortgages/data/multiple/update/${userMortgageId}`,
				{
					values: [
						{
							key: participant,
							subkey: key,
							value: value
						},
						{
							key: key2,
							subkey: participant2,
							value: value2
						}
					]
				},
				{
					headers: { Authorization: `Bearer ${userToken}` }
				}
			)
			.then((response) => {});
	};

	const sendViability = () => {
		axios
			.post(
				`${env.api.url}/mortgages/conventional-viability-mortgage/get-viability/${userMortgageId}`,
				{},
				{
					headers: { Authorization: `Bearer ${userToken}` }
				}
			)
			.then((response) => {});
	};

	const clickNextModal2 = () => {
		if (platform === 'sabadell' && operationType === 'mortgage' && showSavings) {
			const savings = form.getFieldValue('savings');
			axios
				.post(
					`${env.api.url}/mortgages/calculate-ltv-dti/save-mortgage-amount`,
					{ savings, operationId: userMortgageId },
					{ headers: { Authorization: `Bearer ${userToken}` } }
				)
				.then(() => {
					axios
						.post(
							`${env.api.url}/v1/mortgages/data/multiple/update/${userMortgageId}`,
							{
								values: [
									{
										key: 'mortgage',
										subkey: 'savings',
										value: savings
									},
									{
										key: 'process',
										subkey: 'isSabadellSavingsEntered',
										value: true
									}
								]
							},
							{ headers: { Authorization: `Bearer ${userToken}` } }
						)
						.then((response) => {
							if (response.data.success) {
								sendViability();
								setActiveModals(false);
								navigate(`/${userMortgageId}/${clickTab}/automatic-documentation`);
							} else {
								message.error('Ha ocurrido un error');
							}
						});
				});
		} else {
			setActiveModals(false);
			navigate(`/${userMortgageId}/${clickTab}/automatic-documentation`);
		}
	};

	const renderSteps = (
		image: string,
		title: string,
		description: string,
		first: boolean,
		last: boolean
	) => {
		return (
			<Col span={isMobileOnly ? 24 : 8}>
				<div style={{ maxWidth: 230, textAlign: isMobileOnly ? 'left' : 'center' }}>
					{isMobileOnly ? (
						<Row gutter={4}>
							<Col span={4}>
								<div style={{ marginTop: 8 }}>
									<img
										src={`/images/documents/${image}`}
										alt="Documents icon"
										width={32}
										height={32}
									/>
									{!last && (
										<Divider
											type="vertical"
											style={{ borderColor: '#02C3CD', height: 40, marginLeft: 15 }}
										/>
									)}
								</div>
							</Col>
							<Col span={20}>
								<Text style={{ fontSize: 14, fontWeight: 600, color: '#748EA0' }}>
									{' '}
									{t(title)}{' '}
								</Text>{' '}
								<br />
								<Text
									style={{ fontSize: isMobileOnly ? 12 : 14, fontWeight: 400, color: '#2F4858' }}>
									{' '}
									{t(description)}{' '}
								</Text>
							</Col>
						</Row>
					) : (
						<div style={{ marginLeft: !first && 36 }}>
							<Text style={{ fontSize: 14, fontWeight: 600, color: '#748EA0' }}> {t(title)} </Text>{' '}
							<br />
							<Text style={{ fontSize: 14, fontWeight: 400, color: '#2F4858' }}>
								{' '}
								{t(description)}{' '}
							</Text>
						</div>
					)}
				</div>
			</Col>
		);
	};

	const renderContent = () => {
		switch (platform) {
			case 'gibobs':
				return (
					<>
						<div
							style={{
								textAlign: 'center',
								backgroundColor: '#EFFCFC',
								padding: 16,
								borderRadius: 4
							}}>
							{!isMobileOnly && (
								<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
									<img
										src="/images/documents/documents_icon.png"
										alt="Documents icon"
										width={40}
										height={40}
									/>
									<Divider
										style={{
											width: 180,
											minWidth: 0,
											borderColor: '#02C3CD',
											marginLeft: 33,
											marginRight: 33
										}}
									/>
									<img
										src="/images/documents/mirror_icon.png"
										alt="Mirror icon"
										width={40}
										height={40}
									/>
									<Divider
										style={{
											width: 180,
											minWidth: 0,
											borderColor: '#02C3CD',
											marginLeft: 33,
											marginRight: 33
										}}
									/>
									<img
										src="/images/documents/rocket_icon.png"
										alt="Rocket icon"
										width={40}
										height={40}
									/>
								</div>
							)}
							<Row>
								{renderSteps('documents_icon.png', 'doc.complete', 'doc.needBasicDoc', true, false)}
								{renderSteps('mirror_icon.png', 'doc.best', 'doc.showOffers', false, false)}
								{renderSteps('rocket_icon.png', 'doc.choose', 'doc.formalize', false, true)}
							</Row>
							<Row justify={'center'} style={{ marginTop: isMobileOnly ? 8 : 16 }}>
								<Collapse
									onChange={() => setShowSecurity(!showSecurity)}
									className="security"
									expandIconPosition="right"
									bordered={false}
									style={{ background: 'none', padding: '0px !important' }}>
									<Panel
										header={
											<div>
												{t('doc.security')}
												{!showSecurity ? (
													<DownOutlined style={{ marginLeft: 8 }} />
												) : (
													<UpOutlined style={{ marginLeft: 8 }} />
												)}
											</div>
										}
										key="1">
										<Row style={{ textAlign: 'left', width: '100%' }}>
											<div
												style={{
													fontSize: isMobileOnly ? 10 : 12,
													fontWeight: 400,
													color: '#748EA0'
												}}
												dangerouslySetInnerHTML={{
													__html: t('doc.protectedDocs')
												}}></div>
										</Row>
										<Row gutter={16} align={'middle'} style={{ marginTop: 8, textAlign: 'left' }}>
											<Col
												span={isMobileOnly ? 24 : 6}
												style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
												<img src="/images/documents/banco_espana.svg" alt="Bank of Spain icon" />
												<div
													style={{ fontSize: 12, fontWeight: 400, color: '#748EA0' }}
													dangerouslySetInnerHTML={{
														__html: t('doc.spainBank')
													}}></div>
											</Col>
											<Col
												span={isMobileOnly ? 24 : 6}
												style={{
													display: 'flex',
													alignItems: 'center',
													gap: 8,
													marginTop: isMobileOnly && 8
												}}>
												<img
													src="/images/documents/PSD2_stars.svg"
													alt="PSD2 icon"
													width={isMobileOnly ? 24 : 32}
													height={isMobileOnly ? 24 : 32}
												/>
												<div
													style={{ fontSize: 12, fontWeight: 400, color: '#748EA0' }}
													dangerouslySetInnerHTML={{
														__html: t('doc.PSD2')
													}}></div>
											</Col>
											<Col
												span={isMobileOnly ? 24 : 6}
												style={{
													display: 'flex',
													alignItems: 'center',
													gap: 8,
													marginTop: isMobileOnly && 8
												}}>
												<img
													src="/images/documents/icon-rgpd.svg"
													alt="Data protection Icon"
													width={isMobileOnly ? 24 : 32}
													height={isMobileOnly ? 24 : 32}
												/>
												<Text style={{ fontSize: 12, fontWeight: 600, color: '#748EA0' }}>
													{t('loan.adaptedGeneralDataProtection2')}
												</Text>
											</Col>
											<Col
												span={isMobileOnly ? 24 : 6}
												style={{
													display: 'flex',
													alignItems: 'center',
													gap: 8,
													marginTop: isMobileOnly && 8
												}}>
												<LockOutlined style={{ fontSize: 22, color: '#748EA0' }} />
												<div
													style={{ fontSize: 12, fontWeight: 400, color: '#748EA0' }}
													dangerouslySetInnerHTML={{
														__html: t('doc.digitalSecurity')
													}}></div>
											</Col>
										</Row>
									</Panel>
								</Collapse>
							</Row>
						</div>
						<div style={{ marginTop: 16, textAlign: 'center', width: '100%' }}>
							<Text style={{ fontSize: isMobileOnly ? 14 : 16, fontWeight: 600, color: '#2F4858' }}>
								{t('doc.ownerDocs') + ' ' + clickTab.charAt(clickTab.length - 1)}
							</Text>
						</div>
					</>
				);
			case 'sabadell':
				return (
					<>
						<div style={{ marginTop: -24, marginBottom: 24 }}>
							<Text style={{ fontSize: 14, fontWeight: 400, color: '#212121' }}>
								{operationType === 'mortgage' && showSavings
									? t('modalDocument.instructions')
									: t('modalDocument1.Desc1')}
							</Text>
						</div>
						{operationType !== 'mortgage' && showSavings && (
							<div
								style={{
									fontSize: 12,
									fontWeight: 400,
									color: '#748EA0',
									marginTop: 16,
									marginBottom: 24
								}}
								dangerouslySetInnerHTML={{
									__html: t('modalDocument1.Desc2')
								}}></div>
						)}
						{/* Esto lo comentamos de momento porque no hay que mostrar el input de ahorros */}
						{/* {operationType === 'mortgage' && showSavings && (
							<Form layout="horizontal" form={form}>
								<Form.Item
									className="upload-docs-sabadell"
									name="savings"
									style={{ marginTop: 16 }}
									label={
										<Text style={{ color: '#2F4858', fontSize: 10, fontWeight: 400 }}>
											{t('form.Savings')}
										</Text>
									}
									colon={false}
									required>
									<InputNumber
										gbType="currency"
										onChange={(value: any) => {
											value > 0 ? setCloseDisabled(false) : setCloseDisabled(true);
										}}
										style={{ borderColor: closeDisabled ? '#FF7A7B' : '#99C5FF' }}
									/>
								</Form.Item>
							</Form>
						)} */}
					</>
				);
			case 'engel':
				return (
					<>
						<Steps
							direction="horizontal"
							responsive={true}
							className={isMobileOnly ? 'automatic-doc-steps-mobile' : 'automatic-doc-steps'}>
							<Step
								status="process"
								title=""
								description={
									isMobileOnly && (
										<div style={{ maxWidth: 200 }}>
											<Text style={{ fontSize: 14, fontWeight: 700, color: '#262626' }}>
												{t('doc.complete')}
											</Text>
											<br />
											<Text style={{ fontSize: 12, fontWeight: 400, color: '#262626' }}>
												{t('doc.needBasicDoc')}
											</Text>
										</div>
									)
								}
								icon={<img src="/images/documents/document_check.svg" alt="Icono paso 1" />}
							/>
							<Step
								status="process"
								title=""
								description={
									isMobileOnly && (
										<div style={{ maxWidth: 200 }}>
											<Text style={{ fontSize: 14, fontWeight: 700, color: '#262626' }}>
												{t('doc.best')}
											</Text>
											<br />
											<Text style={{ fontSize: 12, fontWeight: 400, color: '#262626' }}>
												{t('doc.showOffers')}
											</Text>
										</div>
									)
								}
								icon={<img src="/images/documents/search.svg" alt="Icono paso 2" />}
							/>
							<Step
								status="process"
								title=""
								description={
									isMobileOnly && (
										<div style={{ maxWidth: 200 }}>
											<Text style={{ fontSize: 14, fontWeight: 700, color: '#262626' }}>
												{t('doc.choose')}
											</Text>
											<br />
											<Text style={{ fontSize: 12, fontWeight: 400, color: '#262626' }}>
												{t('doc.formalize')}
											</Text>
										</div>
									)
								}
								icon={<img src="/images/documents/home.svg" alt="Icono paso 3" />}
							/>
						</Steps>
						{!isMobileOnly && (
							<Row style={{ margin: '0 auto' }} gutter={50}>
								<Col span={8} style={{ textAlign: 'center' }}>
									<div style={{ maxWidth: 200 }}>
										<Text style={{ fontSize: 16, fontWeight: 700, color: '#262626' }}>
											{t('doc.complete')}
										</Text>
										<br />
										<Text style={{ fontSize: 12, fontWeight: 400, color: '#262626' }}>
											{t('doc.needBasicDoc')}
										</Text>
									</div>
								</Col>
								<Col span={8} style={{ textAlign: 'center' }}>
									<div style={{ maxWidth: 200 }}>
										<Text style={{ fontSize: 16, fontWeight: 700, color: '#262626' }}>
											{t('doc.best')}
										</Text>
										<br />
										<Text style={{ fontSize: 12, fontWeight: 400, color: '#262626' }}>
											{t('doc.showOffers')}
										</Text>
									</div>
								</Col>
								<Col span={8} style={{ textAlign: 'center' }}>
									<div style={{ maxWidth: 200 }}>
										<Text style={{ fontSize: 16, fontWeight: 700, color: '#262626' }}>
											{t('doc.choose')}
										</Text>
										<br />
										<Text style={{ fontSize: 12, fontWeight: 400, color: '#262626' }}>
											{t('doc.formalize')}
										</Text>
									</div>
								</Col>
							</Row>
						)}
					</>
				);
			case 'safecredit':
				return (
					<>
						<Steps
							direction="horizontal"
							responsive={true}
							className={isMobileOnly ? 'automatic-doc-steps-mobile' : 'automatic-doc-steps'}>
							<Step
								status="process"
								title=""
								description={
									isMobileOnly && (
										<div style={{ maxWidth: 200 }}>
											<Text style={{ fontSize: 14, fontWeight: 700, color: '#000000' }}>
												{t('doc.complete')}
											</Text>
											<br />
											<Text style={{ fontSize: 12, fontWeight: 400, color: '#000000' }}>
												{t('doc.needBasicDoc')}
											</Text>
										</div>
									)
								}
								icon={<img src="/images/documents/document_check.svg" alt="Icono paso 1" />}
							/>
							<Step
								status="process"
								title=""
								description={
									isMobileOnly && (
										<div style={{ maxWidth: 200 }}>
											<Text style={{ fontSize: 14, fontWeight: 700, color: '#000000' }}>
												{t('doc.best')}
											</Text>
											<br />
											<Text style={{ fontSize: 12, fontWeight: 400, color: '#000000' }}>
												{t('doc.showOffers')}
											</Text>
										</div>
									)
								}
								icon={<img src="/images/documents/search.svg" alt="Icono paso 2" />}
							/>
							<Step
								status="process"
								title=""
								description={
									isMobileOnly && (
										<div style={{ maxWidth: 200 }}>
											<Text style={{ fontSize: 14, fontWeight: 700, color: '#000000' }}>
												{t('doc.choose')}
											</Text>
											<br />
											<Text style={{ fontSize: 12, fontWeight: 400, color: '#000000' }}>
												{t('doc.formalize')}
											</Text>
										</div>
									)
								}
								icon={<img src="/images/documents/home.svg" alt="Icono paso 3" />}
							/>
						</Steps>
						{!isMobileOnly && (
							<Row style={{ margin: '0 auto' }} gutter={50}>
								<Col span={8} style={{ textAlign: 'center' }}>
									<div style={{ maxWidth: 200 }}>
										<Text style={{ fontSize: 14, fontWeight: 700, color: '#000000' }}>
											{t('doc.complete')}
										</Text>
										<br />
										<Text style={{ fontSize: 12, fontWeight: 400, color: '#000000' }}>
											{t('doc.needBasicDoc')}
										</Text>
									</div>
								</Col>
								<Col span={8} style={{ textAlign: 'center' }}>
									<div style={{ maxWidth: 200 }}>
										<Text style={{ fontSize: 14, fontWeight: 700, color: '#000000' }}>
											{t('doc.best')}
										</Text>
										<br />
										<Text style={{ fontSize: 12, fontWeight: 400, color: '#000000' }}>
											{t('doc.showOffers')}
										</Text>
									</div>
								</Col>
								<Col span={8} style={{ textAlign: 'center' }}>
									<div style={{ maxWidth: 200 }}>
										<Text style={{ fontSize: 14, fontWeight: 700, color: '#000000' }}>
											{t('doc.choose')}
										</Text>
										<br />
										<Text style={{ fontSize: 12, fontWeight: 400, color: '#000000' }}>
											{t('doc.formalize')}
										</Text>
									</div>
								</Col>
							</Row>
						)}
					</>
				);
			default:
				return null;
		}
	};

	const renderTitle = () => {
		const defaultColor = '#2F4858';
		const defaultText = t('doc.nextSteps');

		let color = defaultColor;
		let text = defaultText;

		switch (platform) {
			case 'gibobs':
				color = '#2F4858';
				break;
			case 'engel':
				color = '#262626';
				break;
			case 'sabadell':
				color = '#212121';
				text = t('modal1.title1');
				break;
			case 'safecredit':
				color = '#505763';
				break;
			default:
				return null;
		}

		return <Text style={{ fontSize: 16, fontWeight: 600, color: color }}>{text}</Text>;
	};

	const renderFooter = () => {
		if (platform === 'engel' || platform === 'safecredit') {
			return (
				<div style={{ marginTop: !isMobileOnly && 24 }}>
					<Button
						disabled={closeDisabled}
						loading={!closeDisabled && activeButton}
						onClick={() => {
							clickNextModal2();
						}}
						className="button-primary-engel">
						{t('doc.startOwner1')}
					</Button>
					<Divider style={{ marginBottom: isMobileOnly && 8 }} />
					<Row style={{ textAlign: isMobileOnly ? 'left' : 'center' }}>
						<div
							style={{
								fontSize: isMobileOnly ? 10 : 12,
								fontWeight: 400,
								color: '#808080'
							}}
							dangerouslySetInnerHTML={{
								__html: t('doc.protectedDocs')
							}}></div>
					</Row>
					<Row
						gutter={16}
						style={{ marginTop: 8, textAlign: 'left', marginLeft: !isMobileOnly && 15 }}>
						<Col
							span={isMobileOnly ? 12 : 6}
							style={{
								display: 'flex',
								alignItems: 'center',
								gap: 8
							}}>
							<img
								src="/images/documents/banco_espana.svg"
								alt="Bank of Spain icon"
								width={isMobileOnly ? 24 : 32}
								height={isMobileOnly ? 24 : 32}
							/>
							<div
								style={{ fontSize: isMobileOnly ? 8 : 12, fontWeight: 400, color: '#808080' }}
								dangerouslySetInnerHTML={{
									__html: t('doc.spainBank')
								}}></div>
						</Col>
						<Col
							span={isMobileOnly ? 12 : 6}
							style={{
								display: 'flex',
								alignItems: 'center',
								gap: 8,
								marginTop: isMobileOnly && 8
							}}>
							<img
								src="/images/documents/PSD2_stars.svg"
								alt="PSD2 icon"
								width={isMobileOnly ? 24 : 32}
								height={isMobileOnly ? 24 : 32}
							/>
							<div
								style={{ fontSize: isMobileOnly ? 8 : 12, fontWeight: 400, color: '#808080' }}
								dangerouslySetInnerHTML={{
									__html: t('doc.PSD2')
								}}></div>
						</Col>
						<Col
							span={isMobileOnly ? 12 : 6}
							style={{
								display: 'flex',
								alignItems: 'center',
								gap: 8,
								marginTop: isMobileOnly && 8
							}}>
							<img
								src="/images/documents/icon-rgpd.svg"
								alt="Data protection Icon"
								width={isMobileOnly ? 24 : 32}
								height={isMobileOnly ? 24 : 32}
							/>
							<Text style={{ fontSize: isMobileOnly ? 8 : 12, fontWeight: 600, color: '#808080' }}>
								{t('loan.adaptedGeneralDataProtection2')}
							</Text>
						</Col>
						<Col
							span={isMobileOnly ? 12 : 6}
							style={{
								display: 'flex',
								alignItems: 'center',
								gap: 8,
								marginTop: isMobileOnly && 8
							}}>
							<LockOutlined style={{ fontSize: isMobileOnly ? 20 : 22, color: '#808080' }} />
							<div
								style={{ fontSize: isMobileOnly ? 8 : 12, fontWeight: 400, color: '#808080' }}
								dangerouslySetInnerHTML={{
									__html: t('doc.digitalSecurity')
								}}></div>
						</Col>
					</Row>
				</div>
			);
		}
	};

	const renderOkText = () => {
		switch (platform) {
			case 'gibobs':
				return t('doc.start');
			case 'sabadell':
				return t('modalDocument.uploadDocs');
			case 'engel':
				return t('doc.startOwner1');
			case 'safecredit':
				return t('doc.startOwner1');
			default:
				return null;
		}
	};

	return (
		<div>
			<Modal
				className={`${isMobileOnly ? 'ModalCommonSmall ModalDoc' : 'ModalCommon'} ${
					platform !== 'sabadell' && (isMobileOnly ? 'ModalNextStepMobile' : 'ModalNextStep')
				}`}
				open={activeModals}
				onCancel={() => setActiveModals(false)}
				onOk={() => {
					clickNextModal2();
				}}
				footer={renderFooter()}
				width={isMobileOnly ? 328 : platform !== 'sabadell' ? 952 : 480}
				okText={
					<Text style={{ color: '#FFFFFF', fontSize: 14, fontWeight: 600 }}>{renderOkText()}</Text>
				}
				title={renderTitle()}
				cancelButtonProps={{ style: { display: 'none' } }}
				okButtonProps={{
					style: { width: '100%', height: 40, marginLeft: 0 },
					className: `${closeDisabled ? 'disabled-button-sabadell' : ''} button-primari-gibobsNew `,
					disabled: platform !== 'sabadell' ? activeButton : closeDisabled,
					loading: (platform !== 'sabadell' || !closeDisabled) && activeButton
				}}
				destroyOnClose={true}
				closable={platform !== 'sabadell' ? true : !closeDisabled}
				maskClosable={false}>
				{renderContent()}
			</Modal>
		</div>
	);
}

export default AutomaticDocumentationStartupModal;
